<template>
  <vxe-grid ref="engineerRankBySiteTable" v-bind="vxeOption"> </vxe-grid>
</template>

<script>
import {
  engineerRankTableOptionColums,
  tableOption,
} from "@/views/report/indicators/option/tableOption.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      vxeOption: {},
    };
  },
  computed: {
    ...mapGetters(["engineerRankTableBySiteData"]),
  },
  watch: {
    engineerRankTableBySiteData: {
      deep: true,
      handler(newVal, oldVal) {
        this.getTableData();
      },
    },
  },
  methods: {
    getTableData() {
      this.$refs.engineerRankBySiteTable.reloadData(this.engineerRankTableBySiteData.records);
    }
  },
  created() {
    Object.assign(this.vxeOption, tableOption);
    this.vxeOption.columns = engineerRankTableOptionColums;
  },

  mounted() {
  },
};
</script>

<style lang="scss">
</style>